// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__27YL7","title":"Info_title__2OjeS","links":"Info_links__19281","link":"Info_link__3A2CB","logo":"Info_logo__2dNBW"};